//
// Common JS for all the pages
// --------------------------------------------------

import "lazysizes";
import "lazysizes/plugins/unveilhooks/ls.unveilhooks";
import {
	CmpCheck,
	formAddCsrfProtection,
	trackLinkEvent,
	yieldToMainBackground,
} from "./common/utils";

function ready(fn) {
	if (document.readyState !== "loading") {
		fn();
	} else {
		document.addEventListener("DOMContentLoaded", fn);
	}
}

ready(() => {
	// GDPR form
	const gdpr_container = document.querySelector("#_gdpr_form");
	if (gdpr_container) {
		const view_name = gdpr_container.dataset.view_name;
		const page_url = `/misc/approvazione-gdpr/?view=${encodeURI(view_name)}`;
		fetch(page_url, {
			headers: {
				"X-Requested-With": "XMLHttpRequest",
			},
			cache: "no-cache",
		})
			.then((response) => {
				if (response.ok) {
					return response.text();
				}
				console.warn(" --- Error: ", response.statusText);
			})
			.then((data) => {
				if (data) {
					let gdprLightbox = null;
					gdpr_container.insertAdjacentHTML("afterbegin", data);
					document.addEventListener("click", (event) => {
						// toggle button status
						if (
							event.target &&
							event.target.getAttribute("name") === "gdpr_approved"
						) {
							if (event.target.checked) {
								document
									.querySelector("input[name='gdpr_submit']")
									.removeAttribute("disabled");
							} else {
								document
									.querySelector("input[name='gdpr_submit']")
									.setAttribute("disabled", "disabled");
							}
							// form submit
						} else if (
							event.target &&
							event.target.tagName.toLowerCase() === "input" &&
							event.target.getAttribute("name") === "gdpr_submit"
						) {
							const gdpr_form = event.target.closest("form.gdpr_form");

							formAddCsrfProtection(gdpr_form).then((data) => {
								const formData = new FormData();
								for (const el of gdpr_form.querySelectorAll("input")) {
									formData.append(el.getAttribute("name"), el.value);
								}
								fetch(gdpr_form.getAttribute("action"), {
									headers: {
										"X-Requested-With": "XMLHttpRequest",
									},
									method: "POST",
									cache: "no-cache",
									body: formData,
								})
									.then((response) => {
										if (response.ok) {
											return response.json();
										}
										console.warn(" --- Error: ", response.statusText);
										gdprLightbox.close();
									})
									.then((data) => {
										if (data) {
											const show_gdpr = data[0].show_gdpr;
											if (show_gdpr === 0) {
												gdprLightbox.close();
											}
										}
									});
							});
						}
					});

					// lightbox
					import("basiclightbox").then((basicLightbox) => {
						gdprLightbox = basicLightbox.create(gdpr_container);
						gdprLightbox.show();
					});
				}
			});
	}

	// invio evento onclick sui trend
	const trendLink = document.querySelector("a._trend-link");
	if (trendLink) {
		trendLink.addEventListener("click", () => {
			yieldToMainBackground().then(() => {
				trackLinkEvent("menu-trend-link");
			});
		});
	}

	// Menu mobile
	const mobileMenu = document.querySelector("#_mobile_menu");
	const mobileMenuBtn = document.querySelector("#_mobile_menu_btn");
	if (mobileMenu && mobileMenuBtn) {
		mobileMenuBtn.addEventListener("click", () => {
			mobileMenuBtn.classList.toggle("open");
			mobileMenu.classList.toggle("open");
		});
	}

	// Attivazione iframe dopo consenso CMP e push Clarity consent
	window.clarity =
		window.clarity ||
		((...args) => {
			// biome-ignore lint/suspicious/noAssignInExpressions: Clarity script
			(window.clarity.q = window.clarity.q || []).push(args);
		});
	const checkCmp = new CmpCheck();
	checkCmp.checkConsent().then((response) => {
		if (response === true) window.clarity("consent");
		for (const iframe of document.querySelectorAll("._net_activate_iframe")) {
			if (iframe.classList.contains("lazyload")) {
				iframe.setAttribute("data-src", iframe.getAttribute("suppressedsrc"));
			} else {
				iframe.setAttribute("src", iframe.getAttribute("suppressedsrc"));
			}
			iframe.removeAttribute("suppressedsrc");
			iframe.classList.add("_net_activated_iframe");
			iframe.classList.remove("_net_activate_iframe");
		}
	});
});
